import StaffAccountHeader from './StaffAccountHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container, Card } from '@mui/material';
import Footer from 'src/components/Footer';
import React, { useState } from 'react';

import StaffAccountContent from './StaffAccountContent';
import { useAuth } from 'src/hooks/useAuth';
import { API } from '../../../config/config';
import { CreateStaffForm } from './CreateStaffForm';

type StaffComponentState = {
  openModal: boolean,
  email: string
}

function StaffAccountComponent() {
  const { enhancedFetch } = useAuth();

  const [state, setState] = useState<StaffComponentState>({
    openModal: false,
    email: ''
  });
  const [retry, setRetry] = useState(false);
  const showCreateStaffModal = () => {
    setState({ ...state, openModal: true });
  };

  const StaffFormModal = CreateStaffForm({
    onClose: () => {
      setState({ ...state, openModal: false });
    },
    data: {
      email: state.email
    },
    onSubmit: async (data) => {
      const result = await enhancedFetch(`${API.HOST}/api/v1/staff-accounts/invite`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: data.email })
      }).catch((error) => {
        console.log(error);
      })
      setRetry(!retry);
      setState({ ...state, openModal: false });

    },
    fullWidth: false,
    title: 'Create Staff Account',
    isLoading: false,
    openModal: state.openModal,
    maxWidth: 'sm'
  });

  return (
    <>
      <title>Staff Account - Prizeet</title>
      <PageTitleWrapper>
        <StaffAccountHeader onCreateStaffClicked={showCreateStaffModal} />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <StaffAccountContent retry={retry} />
            </Card>
          </Grid>
        </Grid>
        {/*  Add Widget here*/}
        {StaffFormModal}
      </Container>
      <Footer />
    </>
  );
}

export default StaffAccountComponent;
